import {
  API_PREFIX_CATEGORY_PATH,
  API_PREFIX_MENU_PREFERENCE_PATH,
  API_PREFIX_PAGE_PATH,
  API_PREFIX_POST_PATH,
  API_PREFIX_PRODUCT_CATEGORY_PATH,
} from "@/constants/prefix-path-api"
import { message } from "antd"
import { HttpClient } from "../../../../app/api/HttpClient"
import { t } from "../../../../languages/i18n"
import { FilterSearchParams } from "../../../../lib/external-components"

const fetchAllPages = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    publicationState: "preview",
    filters: {},
    pagination: {
      pageSize: "100",
    },
    locale: "all",
  }

  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    if (!excludedKeys.includes(key)) {
      const value = searchTerms[key]

      if (key === "publicationState") {
        const convertParamStatusPost = value === "draft" || value === "all" ? "preview" : "live"
        params.publicationState = convertParamStatusPost

        if (value === "draft") {
          params.filters.publishedAt = { $null: true }
        } else {
          delete params.filters.publishedAt
        }
      } else if (key === "locale") {
        params.locale = value
      } else if (!excludedKeys.includes(key)) {
        if (value) {
          params.filters[key] = { $containsi: value }
        }
      } else if (value) {
        params.pagination = {
          ...params.pagination,
          [key]: value,
        }
      }
    } else {
      const value = searchTerms[key]
      if (value) {
        params.pagination = {
          ...params.pagination,
          [key]: value,
        }
      }
    }
  })

  try {
    const response = await HttpClient.get(`${API_PREFIX_PAGE_PATH}`, { params })

    return {
      data: response.data,
      meta: response.meta,
    }
  } catch (error) {
    message.error(t("Failed to fetch page. Please try again"))
  }
}

const fetchAllPost = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_POST_PATH}`)
    return response
  } catch (error) {
    message.error(t("Failed to fetch posts. Please try again."))
  }
}
const fetchAllBases = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_MENU_PREFERENCE_PATH}`)

    return response
  } catch (error) {
    message.error("Failed to fetch pages. Please try again.")
  }
}

const fetchAllCategories = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_CATEGORY_PATH}`)

    return response
  } catch (error) {
    message.error("Failed to fetch categories. Please try again.")
  }
}

const fetchAllMenuPreference = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_MENU_PREFERENCE_PATH}`, {
      params: {
        populate: "*",
        locale: "all",
      },
    })
    return response
  } catch (error) {
    message.error("Failed to fetch categories. Please try again.")
  }
}

const fetchAllProductCategories = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_PRODUCT_CATEGORY_PATH}`)
    return response
  } catch (error) {
    message.error("Failed to fetch product categories. Please try again.")
  }
}

const menuService = {
  fetchAllPages,
  fetchAllPost,
  fetchAllCategories,
  fetchAllBases,
  fetchAllMenuPreference,
  fetchAllProductCategories,
}

export default menuService
